// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-row {
  display: flex;
  gap: 20px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content {
  width: 612px;
  flex-shrink: 0;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card {
  height: 100%;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner {
  padding: 16px;
  height: 100%;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner.card-inner--column {
  display: flex;
  flex-direction: column;
}


.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner .BC-Switch-Status {
  height: 16px;
  width: 34px;
  margin-right: 8px;
  display: inline-flex;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {
  width: 34px;
  height: 16px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {
  width: 16px;
  height: 16px;
  transform: translateX(0);
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Table {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Cell:first-child {
  width: 45%;
  white-space: wrap;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Cell:last-child {
  width: 55%;
  white-space: wrap;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__TableRow:nth-child(odd) {
  background-color: #FAFBFB;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .guide {
  margin-bottom: 8px;
  margin-top: 16px;
  text-align: left;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .guide .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .guide .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  margin-left: 2px;
}


.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page.BC-Page__AttentiveIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Page.BC-Page__AttentiveIntegration .BC-Page__Title--Help {
  padding-left: 53px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .divider {
  border: 1px solid #E1E3E5;
  margin-bottom: 24px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 12px 16px;
  background: #FAFBFB;
  border: 1px solid transparent;
  border-radius: 4px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item:hover {
  border: 1px solid #1F5199;
  background: #EDF4FE;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item__title {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .recommendation-item__title .text-ai {
  background: linear-gradient(135.64deg, #C830E1 16.99%, #FE4A25 84.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}


.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .recommendation-item__title .Polaris-Badge {
  background: #FF30001A;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .recommendation-item__title .Polaris-Badge>span {
  display: flex;
  align-items: center;
  gap: 2px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .Polaris-ButtonGroup {
  flex-shrink: 0;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:first-child .Polaris-Button {
  padding: 5px;
  min-width: 30px;
  min-height: 30px;
  width: 30px;
  height: 30px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:last-child .Polaris-Button {
  padding: 5px 12px;
  width: 78px;
  height: 30px;
  min-height: 30px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .text-coming-soon {
  font-weight: 600;
  font-size: 16px;
  margin: 2px 0;
  line-height: 24px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .card-inner--center {
  text-align: center;
  padding-bottom: 20px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__toggle {
  background-color: #FAFBFB;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-wrapper:first-child .attentive-event-collapse__toggle {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-wrapper:last-child .attentive-event-collapse__toggle {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 0;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__content {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__content .attentive-event-collapse__content__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-basis: 50%;
  padding-left: 24px;
}

.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__content p {
  flex-basis: 50%;
  text-align: left;
}

.BC-Page.BC-Page__AttentiveIntegration~#PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {
  max-width: 1015px;
}

.BC-Page.BC-Page__AttentiveIntegration .card-inner__flex {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page.BC-Page__AttentiveIntegration .card-inner__flex .BC-Checkbox-Status {
  margin-right: 0;
}

.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction {
  padding-left: 42px;
  margin-top: 4px;
  color: rgb(109, 113, 117);
  display: flex;
}

.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction .Polaris-Link {
  display: inline-flex;
  margin-left: 4px;
  text-decoration: underline;
}

.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction .Polaris-Icon {
  margin: 0;
  width: 18px;
  height: 18px;
  margin-left: 2px;
}

.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg {
  fill: rgb(44, 110, 203);
}

.callback-attentive {
  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.callback-attentive .callback-attentive__title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/styles/attentive.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iEAAiE;EACjE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-row {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content {\n  width: 612px;\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner {\n  padding: 16px;\n  height: 100%;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner.card-inner--column {\n  display: flex;\n  flex-direction: column;\n}\n\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner .BC-Switch-Status {\n  height: 16px;\n  width: 34px;\n  margin-right: 8px;\n  display: inline-flex;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {\n  width: 16px;\n  height: 16px;\n  transform: translateX(0);\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Table {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Cell:first-child {\n  width: 45%;\n  white-space: wrap;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Cell:last-child {\n  width: 55%;\n  white-space: wrap;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__TableRow:nth-child(odd) {\n  background-color: #FAFBFB;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .guide {\n  margin-bottom: 8px;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .guide .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .guide .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  margin-left: 2px;\n}\n\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .BC-Page__Title--Help {\n  padding-left: 53px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .divider {\n  border: 1px solid #E1E3E5;\n  margin-bottom: 24px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  padding: 12px 16px;\n  background: #FAFBFB;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item:hover {\n  border: 1px solid #1F5199;\n  background: #EDF4FE;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item__title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .recommendation-item__title .text-ai {\n  background: linear-gradient(135.64deg, #C830E1 16.99%, #FE4A25 84.55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 600;\n}\n\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .recommendation-item__title .Polaris-Badge {\n  background: #FF30001A;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .recommendation-item__title .Polaris-Badge>span {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .Polaris-ButtonGroup {\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:first-child .Polaris-Button {\n  padding: 5px;\n  min-width: 30px;\n  min-height: 30px;\n  width: 30px;\n  height: 30px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .recommendation-item .Polaris-ButtonGroup .Polaris-ButtonGroup__Item:last-child .Polaris-Button {\n  padding: 5px 12px;\n  width: 78px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .text-coming-soon {\n  font-weight: 600;\n  font-size: 16px;\n  margin: 2px 0;\n  line-height: 24px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .card-inner--center {\n  text-align: center;\n  padding-bottom: 20px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__toggle {\n  background-color: #FAFBFB;\n  padding: 12px 16px;\n  display: flex;\n  gap: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-wrapper:first-child .attentive-event-collapse__toggle {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-wrapper:last-child .attentive-event-collapse__toggle {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom: 0;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__content {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__content .attentive-event-collapse__content__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-basis: 50%;\n  padding-left: 24px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .attentive-container .attentive-col-content .attentive-event .attentive-event-collapse__content p {\n  flex-basis: 50%;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration~#PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {\n  max-width: 1015px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .card-inner__flex {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .card-inner__flex .BC-Checkbox-Status {\n  margin-right: 0;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction {\n  padding-left: 42px;\n  margin-top: 4px;\n  color: rgb(109, 113, 117);\n  display: flex;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction .Polaris-Link {\n  display: inline-flex;\n  margin-left: 4px;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction .Polaris-Icon {\n  margin: 0;\n  width: 18px;\n  height: 18px;\n  margin-left: 2px;\n}\n\n.BC-Page.BC-Page__AttentiveIntegration .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg {\n  fill: rgb(44, 110, 203);\n}\n\n.callback-attentive {\n  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 40px 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.callback-attentive .callback-attentive__title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  text-align: center;\n  margin-top: 12px;\n  margin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
